import { createReducer } from '@common/redux-utils';
import {
  ContractBalancesActionType,
  SetPaymentSourcesAction,
  SetContractBalancesAction,
  SelectBalanceAction,
  ClearBalancesAction
} from './contract-balances.actions';
import { OptionsViewModel } from '@models/common.models';
import { ContractBalancesViewModel } from '@models/Contract';

export interface ContractBalancesState {
  readonly paymentSources: Array<OptionsViewModel>;
  readonly balancesList: Array<ContractBalancesViewModel>;
  readonly selectedBalances: Array<ContractBalancesViewModel>;
}

export const initContractBalancesState: ContractBalancesState = {
  paymentSources: [],
  balancesList: [],
  selectedBalances: []
};

function handleSetPaymentSources(state: ContractBalancesState, action: SetPaymentSourcesAction): ContractBalancesState {
  return {
    ...state,
    paymentSources: action.paymentSources
  };
}

function handleSetContractBalances(
  state: ContractBalancesState,
  action: SetContractBalancesAction
): ContractBalancesState {
  return {
    ...state,
    balancesList: action.balances
  };
}

function handleSelectBalance(state: ContractBalancesState, action: SelectBalanceAction): ContractBalancesState {
  let selectedBalances =
    state.selectedBalances.indexOf(action.balance) > -1
      ? state.selectedBalances.filter(balance => balance !== action.balance)
      : [...state.selectedBalances, action.balance];
  selectedBalances = selectedBalances.filter(balance => balance !== null).filter(balance => balance !== undefined);
  return {
    ...state,
    selectedBalances: selectedBalances
  };
}

function handleClearBalances(state: ContractBalancesState, action: ClearBalancesAction): ContractBalancesState {
  return {
    ...state,
    balancesList: [],
    selectedBalances: []
  };
}

export const ContractBalancesReducer = createReducer<ContractBalancesState, ContractBalancesActionType>(
  initContractBalancesState,
  {
    [ContractBalancesActionType.SetPaymentSources]: handleSetPaymentSources,
    [ContractBalancesActionType.SetContractBalances]: handleSetContractBalances,
    [ContractBalancesActionType.SelectBalance]: handleSelectBalance,
    [ContractBalancesActionType.ClearBalances]: handleClearBalances
  }
);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-balances/contract-balances.reducer.tsx